ci_states.state('signup', {
    url: '/signup',
    templateUrl: 'partials/user/signup.html',
    controller: 'SignupController'
}).state('login', {
    url: '/login',
    templateUrl: 'partials/user/login.html',
    controller: 'LoginController'
}).state('profile', {
    url: '/profile',
    templateUrl: 'partials/user/user_view.html',
    controller: 'UserProfileController',
    ncyBreadcrumb: {
        label: 'My Profile'
    }
}).state('forgot_password', {
    url: '/forgot_password',
    templateUrl: 'partials/user/forgot_password.html',
    controller: 'ForgotPasswordController'
}).state('reset_password', {
    url: '/reset_password/:id/:token',
    templateUrl: 'partials/user/reset_password.html',
    controller: 'ResetPasswordController'
}).state('users', {
    url: '/users',
    templateUrl: 'partials/user/user_list.html',
    controller: 'UserListController',
    ncyBreadcrumb: {
        label: 'Users'
    }
}).state('users_view', {
    url: '/users/:id',
    templateUrl: 'partials/user/user_view.html',
    controller: 'UserViewController',
    ncyBreadcrumb: {
        parent: 'users',
        label: '{{ user.username || user.email }}'
    }
});